module.exports = __webpack_public_path__ + "img/newicon4on.6692b890.svg";